import { AuthGuard } from './auth-guard.service';
import { AuthService } from './auth.service';
import { EmailGuard } from './email-guard.service';
import { MFAVerificationGuard } from './mfa-verification-guard.service';

export const services = [AuthGuard, AuthService, EmailGuard, MFAVerificationGuard];
